import Button from "components/button"
import Input from "components/input"
import { useState } from "react"
import { useLocalStorage } from "react-use"
import textServices from "services/text-services"
import { Checkbox, DivCheckbox, PCheckbox } from "theme/theme"

function AllowCookies({ onSubmit }) {

  const [referralCode, setReferralCode] = useState()
  const [referral] = useLocalStorage<string>('referralCode', '')
  const [termsOfUse, setTermsOfUse] = useState(false)
  const [subscribe, setSubscribe] = useState(false)

  const handleSubscribe = () => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'MODIFICAR INFORMACION - Acepto recibir novedades', value: '10' })
    setSubscribe((state) => !state)
  }

  const handleTermsOfUse = () => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'MODIFICAR INFORMACION - Acepto terminos y condiciones de privacidad', value: '10' })
    setTermsOfUse((state) => !state)
  }

  const handleOnChange = (e) => {
    const { value } = e.target
    setReferralCode(value)
  }

  const handleSubmit = () => {
    if (!termsOfUse) {
      return alert('Debes aceptar los términos y condiciones')
    }
    onSubmit({ termsOfUse, subscribe: subscribe, code: referralCode })
    localStorage.setItem('allowCookies', 'yes')
  }

  return (
    <section className="flex-1 flex flex-col items-center large-screen-padding" style={{ maxHeight: 1080 }}>
      <div className="flex-1 flex flex-col items-center justify-center bg-cover md:bg-contain bg-no-repeat bg-center gap-3 w-full">
        <img src={`${AZURE_BASE_URL}/allowcookies.png`} alt="allowcookies" className="w-full" />
      </div>
      <div className="flex flex-col items-center justify-center gap-5 px-8 pb-8 w-full">
        {THEME_CONFIG.allowReferral && (
          <>
            <p className="dinPro font-medium text-base text-center">{textServices.findByText('allowcookies/subtitle', 'INGRESA SU CÓDIGO DE REFERIDO')}</p>
            <Input type="text" defaultValue={referral ?? undefined} onChange={handleOnChange} placeholder="WFF7759" className="text-center saira font-bold text-sm" />
          </>
        )}
        <div className="flex gap-3 flex-col">
          <DivCheckbox className="gap-4 flex items-center cursor-pointer" onClick={handleTermsOfUse}>
            <Checkbox active={termsOfUse} className={`h-6 w-6 flex items-center justify-center`} id="termsOfUse" />
            <PCheckbox className="dinPro">Acepto los <a href={`${process.env.PUBLIC_URL}/terms-and-conditions`} rel="noreferrer" target="_blank" className="underline">Términos y Condiciones</a> y el <a href={`${process.env.PUBLIC_URL}/privacy-politics`} rel="noreferrer" target="_blank" className="underline">Aviso de privacidad</a>.</PCheckbox>
          </DivCheckbox>
          <DivCheckbox className="gap-4 flex items-center cursor-pointer" onClick={handleSubscribe}>
            <Checkbox className={`h-6 w-6 flex items-center justify-center`} id="suscribe" active={subscribe} />
            <PCheckbox className="dinPro">Quiero recibir novedades.</PCheckbox>
          </DivCheckbox>
        </div>
        <Button onClick={handleSubmit}>
          SIGUIENTE
        </Button>
      </div>
    </section >
  )
}

export default AllowCookies